import { BaseModelDto } from '../base-model/base-model.dto';
import { TimeProjetoStatus } from './time-projeto-status.enum';

export class TimeProjetoDto extends BaseModelDto {
  id: number;
  timeId: number;
  projetoId: number;
  status: TimeProjetoStatus;
}
